import { RequirementForm } from "./RequirementForm";

const EditRequirement = () => {
  return <RequirementForm edit />;
};

export { EditRequirement };
